var ItemSerializer, _,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

_ = require('underscore-plus');

ItemSerializer = (function() {

  /*
  Section: Format Constants
   */
  ItemSerializer.ItemReferencesType = 'application/json+item-ids';

  ItemSerializer.BMLType = 'text/bml+html';

  ItemSerializer.BMLMimeType = ItemSerializer.BMLType;

  ItemSerializer.OPMLType = 'text/opml+xml';

  ItemSerializer.OPMLMimeType = ItemSerializer.OPMLType;

  ItemSerializer.TaskPaperType = 'text/taskpaper';

  ItemSerializer.TaskPaperMimeType = ItemSerializer.TaskPaperType;

  ItemSerializer.TEXTType = 'text/plain';

  ItemSerializer.TEXTMimeType = ItemSerializer.TEXTType;

  ItemSerializer.UTIToTypeMap = {
    'public.plain-text': ItemSerializer.TEXTType,
    'public.utf8-plain-text': ItemSerializer.TEXTType,
    'com.hogbaysoftware.ItemReferencePboardType': ItemSerializer.ItemReferencesType,
    'com.hogbaysoftware.BirchMarkupLanguagePboardType': ItemSerializer.BMLType
  };

  ItemSerializer.serializations = [];

  function ItemSerializer() {
    throw new Error('This is a static class');
  }

  ItemSerializer.registerSerialization = function(serialization) {
    if (serialization.priority == null) {
      serialization.priority = Number.Infinity;
    }
    this.serializations.push(serialization);
    return this.serializations.sort(function(a, b) {
      return a.priority - b.priority;
    });
  };

  ItemSerializer.getSerializationsForType = function(type) {
    var each, results;
    if (this.UTIToTypeMap[type]) {
      type = this.UTIToTypeMap[type];
    }
    results = (function() {
      var i, len, ref, results1;
      ref = this.serializations;
      results1 = [];
      for (i = 0, len = ref.length; i < len; i++) {
        each = ref[i];
        if (indexOf.call(each.types, type) >= 0) {
          results1.push(each.serialization);
        }
      }
      return results1;
    }).call(this);
    if (results.length === 0) {
      results = this.getSerializationsForType(ItemSerializer.TEXTType);
    }
    return results;
  };

  ItemSerializer.getSerializationsForExtension = function(extension) {
    var each, results;
    if (extension == null) {
      extension = '';
    }
    extension = extension.toLowerCase();
    results = (function() {
      var i, len, ref, results1;
      ref = this.serializations;
      results1 = [];
      for (i = 0, len = ref.length; i < len; i++) {
        each = ref[i];
        if (indexOf.call(each.extensions, extension) >= 0) {
          results1.push(each.serialization);
        }
      }
      return results1;
    }).call(this);
    if (results.length === 0) {
      results = this.getSerializationsForType(ItemSerializer.TEXTType);
    }
    return results;
  };


  /*
  Section: Serialize & Deserialize Items
   */

  ItemSerializer.serializeItems = function(items, options, legacyOptions) {
    var context, each, emptyEncodeLastItem, endOffset, firstItem, i, itemBody, itemStack, j, lastItem, len, len1, ref, ref1, ref2, ref3, serialization, startOffset;
    if (options == null) {
      options = {};
    }
    if (typeof legacyOptions === 'string') {
      options = {
        type: legacyOptions
      };
    }
    firstItem = items[0];
    lastItem = items[items.length - 1];
    if (options.type == null) {
      options.type = (ref = (ref1 = items[0]) != null ? ref1.outline.type : void 0) != null ? ref : ItemSerializer.BMLType;
    }
    if (options.startOffset == null) {
      options.startOffset = 0;
    }
    if (options.endOffset == null) {
      options.endOffset = (ref2 = lastItem != null ? lastItem.bodyString.length : void 0) != null ? ref2 : 0;
    }
    if (options.baseDepth == null) {
      options.baseDepth = Number.MAX_VALUE;
    }
    serialization = ((function() {
      var i, len, ref3, results1;
      ref3 = this.getSerializationsForType(options['type']);
      results1 = [];
      for (i = 0, len = ref3.length; i < len; i++) {
        each = ref3[i];
        if (each.beginSerialization) {
          results1.push(each);
        }
      }
      return results1;
    }).call(this))[0];
    startOffset = options.startOffset;
    endOffset = options.endOffset;
    emptyEncodeLastItem = false;
    context = {};
    if (items.length > 1 && endOffset === 0) {
      items.pop();
      lastItem = items[items.length - 1];
      endOffset = lastItem.bodyString.length;
      emptyEncodeLastItem = true;
    }
    for (i = 0, len = items.length; i < len; i++) {
      each = items[i];
      if (each.depth < options.baseDepth) {
        options.baseDepth = each.depth;
      }
    }
    serialization.beginSerialization(items, options, context);
    if (items.length === 1) {
      serialization.beginSerializeItem(items[0], options, context);
      serialization.serializeItemBody(items[0], items[0].bodyAttributedSubstringFromRange(startOffset, endOffset - startOffset), options, context);
      serialization.endSerializeItem(items[0], options, context);
    } else {
      itemStack = [];
      for (j = 0, len1 = items.length; j < len1; j++) {
        each = items[j];
        while (((ref3 = itemStack[itemStack.length - 1]) != null ? ref3.depth : void 0) >= each.depth) {
          serialization.endSerializeItem(itemStack.pop(), options, context);
        }
        itemStack.push(each);
        serialization.beginSerializeItem(each, options, context);
        itemBody = each.bodyAttributedString;
        if (each === firstItem) {
          itemBody = itemBody.attributedSubstringFromRange(startOffset, itemBody.length - startOffset);
        } else if (each === lastItem) {
          itemBody = itemBody.attributedSubstringFromRange(0, endOffset);
        }
        serialization.serializeItemBody(each, itemBody, options, context);
      }
      while (itemStack.length) {
        serialization.endSerializeItem(itemStack.pop(), options, context);
      }
    }
    if (emptyEncodeLastItem) {
      if (typeof serialization.emptyEncodeLastItem === "function") {
        serialization.emptyEncodeLastItem(options, context);
      }
    }
    return serialization.endSerialization(options, context);
  };

  ItemSerializer.deserializeItems = function(serializedItems, outline, options) {
    var each, ref, serialization;
    if (options == null) {
      options = {};
    }
    if (typeof options === 'string') {
      options = {
        type: options
      };
    }
    if (options['type'] == null) {
      options['type'] = (ref = outline.type) != null ? ref : ItemSerializer.BMLType;
    }
    serialization = ((function() {
      var i, len, ref1, results1;
      ref1 = this.getSerializationsForType(options['type']);
      results1 = [];
      for (i = 0, len = ref1.length; i < len; i++) {
        each = ref1[i];
        if (each.deserializeItems) {
          results1.push(each);
        }
      }
      return results1;
    }).call(this))[0];
    return serialization.deserializeItems(serializedItems, outline, options);
  };

  return ItemSerializer;

})();

ItemSerializer.registerSerialization({
  priority: 0,
  extensions: [],
  types: [ItemSerializer.ItemReferencesType],
  serialization: require('./serializations/item-references')
});

ItemSerializer.registerSerialization({
  priority: 1,
  extensions: ['bml'],
  types: [ItemSerializer.BMLType],
  serialization: require('./serializations/bml')
});

ItemSerializer.registerSerialization({
  priority: 2,
  extensions: ['opml'],
  types: [ItemSerializer.OPMLType],
  serialization: require('./serializations/opml')
});

ItemSerializer.registerSerialization({
  priority: 3,
  extensions: ['taskpaper'],
  types: [ItemSerializer.TaskPaperType],
  serialization: require('./serializations/taskpaper')
});

ItemSerializer.registerSerialization({
  priority: 4,
  extensions: [],
  types: ['NSFilenamesPboardType'],
  serialization: require('./serializations/paths')
});

ItemSerializer.registerSerialization({
  priority: 5,
  extensions: [],
  types: [ItemSerializer.TEXTType],
  serialization: require('./serializations/text')
});

module.exports = ItemSerializer;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/item-serializer.js
 ** module id = 73
 ** module chunks = 0
 **/